import { render } from "./BannerNew.vue?vue&type=template&id=6d9f9c97&scoped=true"
import script from "./BannerNew.vue?vue&type=script&lang=js"
export * from "./BannerNew.vue?vue&type=script&lang=js"

import "./BannerNew.vue?vue&type=style&index=0&id=6d9f9c97&lang=scss&scoped=true"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9f9c97"]])

export default __exports__